export default __webpack_public_path__ + "static/tablets-87131c6bd446298e10e09acbc4a1fc35.png";